import { contactCard } from './contactCard';

export const lenderContactCard = contactCard(
  'additionalContacts.lender',
  'lender',
);
